import ShoppingBagIcon from "@redotech/redo-icons/shopping-bag-01.svg";
import { NumberFilterOperator } from "@redotech/redo-model/views/advanced-filters/number-filter";
import { fgFilterEntries } from "@redotech/redo-model/views/fulfillment/fg-filter-catalog";
import { AdvancedTableFilter } from "@redotech/redo-web/advanced-filters/advanced-filter";

const entry = fgFilterEntries.expandedItemQuantity;

export const ExpandedItemQuantityFilter: AdvancedTableFilter = {
  type: entry.type,
  Icon: ShoppingBagIcon,
  min: 0,
  data: {
    name: entry.name,
    type: entry.type,
    value: null,
    operator: NumberFilterOperator.GREATER_THAN,
  },
  displayName: entry.displayName,
};
